import React from "react";
import _ from "lodash";

export function toReactNodeArray(children: React.ReactNode | React.ReactNodeArray): React.ReactNodeArray {
    return _.isArray(children) ? children : [children];
}
